import { Button } from '@mantine/core';
import { IconPencilPlus } from '@tabler/icons-react';
import { useModal } from '../../../hooks/useModal';
import { lightGreyIconButtonStyle } from '../../../theme/styling/buttonStyling';
import { defaultIconStyle } from '../../../theme/styling/iconStyling';
import { NewBarcodeModal } from './NewBarcodeModal';

interface NewBarcodeModalProps {
	skuid: string;
	triggerListUpdate: () => void;
}

export function NewBarcodeButton({
	skuid,
	triggerListUpdate,
}: NewBarcodeModalProps) {
	const newModal = useModal();

	return (
		<>
			<Button {...lightGreyIconButtonStyle} onClick={() => newModal.open()}>
				<IconPencilPlus {...defaultIconStyle} />
			</Button>
			<NewBarcodeModal
				close={newModal.close}
				isOpened={newModal.isOpen}
				triggerListUpdate={triggerListUpdate}
				skuid={skuid}
			/>
		</>
	);
}
